<div class="healthcars">
  <div class="healthcar-header">
    <h2>Healthcare Service-Verwaltung</h2>

    <div class="healthcar-header-searchbar">
      <app-searchbar
        (searchTermChange)="onSearchTerms($event)"
        id="searchbar-healthcare"
        class="searchbar"
        placeholder="Schnellsuche"
        [dataTestId]="testIds.inputHealthcareserviceSearch">
      </app-searchbar>
    </div>
  </div>

  <div class="filter-row" [attr.data-testid]="testIds.filterRow">
    <span class="filter-label" [attr.data-testid]="testIds.filterLabel">Filter</span>

    <div class="filter-controls" [attr.data-testid]="testIds.filterControls">
      <mat-form-field appearance="outline" class="custom-filter-field">
        <mat-select
          (selectionChange)="setFilter($event)"
          [(value)]="filterKey"
          [attr.data-testid]="testIds.filterSelection"
          placeholder="Content">
          <mat-option [attr.data-testid]="testIds.optionOwn" value="own">Eigene</mat-option>
          <mat-option [attr.data-testid]="testIds.optionAll" value="all">Alle</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="interaction-wrapper">
        <app-tonal-button
          (clicked)="openDialog(endpointDialog, true, $event)"
          buttonText="Healthcareservice anlegen"
          [dataTestId]="testIds.createHealthcareServiceButton"></app-tonal-button>

        <app-tonal-button
          (clicked)="deleteHealthcareService()"
          [icon]="'minus'"
          buttonText="Healthcareservice löschen"
          [dataTestId]="testIds.deleteHealthcareserviceButton">
        </app-tonal-button>

        <app-tonal-button
          buttonText="Healthcareservice bearbeiten"
          [icon]="'edit'"
          [dataTestId]="testIds.updateHealthcareserviceButton"
          (clicked)="openDialog(endpointDialog, false, $event)">
        </app-tonal-button>

        <ng-template #endpointDialog class="endpointDialog-container">
          <div class="header-container">
            <h1 class="header">Neuen Endpunkt anlegen</h1>
            <h2 class="sub-header">Erstellen Sie hier ihren neuen Endpunkt</h2>
          </div>

          <form
            [formGroup]="healthcareServiceForm"
            class="dialog-form scrollable-form"
            [attr.data-testid]="testIds.formCreateEndpoint">
            <mat-label>Healthcare Service Id</mat-label>
            <span [attr.data-testid]="testIds.fieldHealthcareServiceId">{{ selectedRessource?.hcs?.id }}</span>
            <mat-form-field class="input-container" [attr.data-testid]="testIds.fieldHealthcareservicename">
              <mat-label>Healthcare Service Name</mat-label>
              <input
                [attr.data-testid]="testIds.fieldHealthcareservicenameInput"
                formControlName="healthcareServiceName"
                matInput
                required />
            </mat-form-field>
            <mat-label>Organization ID</mat-label>
            <span [attr.data-testid]="testIds.fieldOrganizationid"> {{ selectedRessource?.organization?.id }}</span>
            <mat-label>Organization Name</mat-label>
            <span [attr.data-testid]="testIds.fieldOrganizationname"> {{ selectedRessource?.organization?.name }}</span>

            <div class="endpoints-section">
              <div class="endpoints-header">
                <h3>Endpoints</h3>
              </div>

              @for (endpoint of endpoints; track endpoint; let i = $index) {
                <div class="endpoint-group" [formGroup]="endpoint">
                  <div class="endpoint-header">
                    <h4>Endpoint {{ i + 1 }}</h4>
                    <div
                      (keydown)="$event.stopPropagation()"
                      class="remove-endpoint-clickable"
                      (click)="removeEndpoint(i)"
                      [attr.data-testid]="'remove_endpoint_button' + i">
                      <mat-icon svgIcon="delete-icon" [attr.data-testid]="testIds.removeEndpointIcon"></mat-icon>
                      <span>Entfernen</span>
                    </div>
                  </div>

                  <div class="endpoint-fields">
                    <mat-form-field class="input-container" [attr.data-testid]="'field_endpoint_name' + i">
                      <mat-label>Endpoint Name</mat-label>
                      <input
                        matInput
                        formControlName="endpointName"
                        [attr.data-testid]="'field_endpoint_name_input' + i"
                        required />
                    </mat-form-field>

                    <mat-form-field class="input-container" [attr.data-testid]="'field_endpoint_address' + i">
                      <mat-label>Endpoint Address (MXID)</mat-label>
                      <input
                        matInput
                        formControlName="endpointAddress"
                        (blur)="onBlur(endpoint)"
                        [attr.data-testid]="'field_endpoint_address_input' + i"
                        required />
                      <span matTextPrefix>matrix:u/</span>
                    </mat-form-field>
                    @if (endpoint.controls['endpointAddress'].dirty && endpoint.controls['endpointAddress'].errors) {
                      <ul class="error">
                        @for (errors of endpoint.controls['endpointAddress'].errors | keyvalue; track errors) {
                          @if (errors.key.includes('required')) {
                            <li>
                              <span class="error-message">Es muss eine MatrixId zum anlegen vergeben werden.</span>
                            </li>
                          } @else {
                            <li>
                              <span class="error-message">{{ errors.value }}</span>
                            </li>
                          }
                        }
                      </ul>
                    }

                    <mat-form-field class="input-container" [attr.data-testid]="'field_connection_type' + i">
                      <mat-label>Connection Type</mat-label>
                      <mat-select
                        formControlName="connectionType"
                        [attr.data-testid]="'field_connection_type_select' + i">
                        <mat-option value="tim" [attr.data-testid]="'connection_type_tim' + i">
                          TI-Messenger Endpunkt
                        </mat-option>
                        <mat-option value="tim-fa" [attr.data-testid]="'connection_type_timfa' + i">
                          TI-Messenger Funktionsaccount
                        </mat-option>
                        <mat-option value="tim-bot" [attr.data-testid]="'connection_type_timbot' + i">
                          TI-Messenger Chatbot
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <app-settings-slider
                      [modelNg]="endpoint.get('hideFromInsurees')?.value"
                      (modelNgChange)="updateHideFromInsurees(endpoint, $event)"
                      settingDescriptor="Verstecken vor Versicherten?"
                      [attr.data-testid]="'hide_from_insurees_toggle' + i">
                    </app-settings-slider>
                  </div>

                  <hr class="endpoint-divider" />
                </div>
              }
              <div
                (click)="addEndpoint()"
                (keydown)="addEndpoint()"
                class="add-endpoint-clickable"
                [attr.data-testid]="testIds.addEndpointButton">
                <mat-icon [attr.data-testid]="testIds.addEndpointIcon" svgIcon="plus-icon"></mat-icon>
                <span>NEU</span>
              </div>
            </div>

            <div class="button-container">
              <app-button (clicked)="resetEndpointForm()" [dataTestId]="testIds.buttonCancelEdit" text="Abbrechen">
              </app-button>

              <app-button
                (clicked)="handleDialog(!!selectedRessource)"
                [isPrimary]="true"
                [isDisabled]="healthcareServiceForm.invalid"
                [text]="isCreate ? 'Erstellen' : 'Aktualisieren'"
                [dataTestId]="testIds.buttonConfirmEdit">
              </app-button>
            </div>
          </form>
        </ng-template>

        <app-table-settings
          [allColumns]="displayedColumns"
          [displayedColumns]="columsToDisplay"
          [attr.data-testid]="testIds.tableSettingsComponent">
        </app-table-settings>
      </div>
    </div>
  </div>

  <app-generic-table
    [columnsToDisplay]="columsToDisplay"
    [dataSource]="(dataSource$ | async)!"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)"
    [totalItems]="total"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    (rowClick)="onSelect($event)"
    [showPaging]="false"
    [pageIndex]="pageIndex"
    [attr.data-testid]="testIds.orgHcsTable">
  </app-generic-table>
</div>
